import { METRICS } from "../../data/content";
import { CountUp } from "./CountUp";
import { Reveal } from "./Reveal";

export const Metrics = () => (
  <section className="section section--dark" aria-labelledby="metrics-heading">
    <div className="container">
      <div className="section-header" style={{ textAlign: "center" }}>
        <div className="section-label">By The Numbers</div>
        <h2 className="section-heading" id="metrics-heading">
          Evidence-Driven <em>Impact at Scale</em>
        </h2>
      </div>
      <div className="metrics-grid">
        {METRICS.map((m, i) => {
          const Icon = m.icon;
          return (
            <Reveal className="metric-card" key={m.label} delay={i * 60} data-testid={`metric-card-${i}`}>
              <div className="metric-icon"><Icon size={28} strokeWidth={1.5} /></div>
              <div className="metric-number">
                {m.static ? m.static : <CountUp value={m.count} suffix={m.suffix} />}
              </div>
              <div className="metric-label">{m.label}</div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
